// src/components/Blog.js

import React, { useState, useEffect } from 'react';

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [activeCat, setActiveCat] = useState('All Insights');
    const [search, setSearch] = useState('');
    const categories = ['All Insights', 'Governance', 'NEP 2020', 'Technology', 'Procurement', 'Pedagogy'];

    useEffect(() => {
        fetch('/api/blogs')
            .then(res => res.json())
            .then(data => setPosts(data))
            .catch(e => console.error(e));
    }, []);

    const filteredPosts = posts.filter(p => {
        const matchesCat = activeCat === 'All Insights' || p.category === activeCat;
        const matchesSearch = p.title.toLowerCase().includes(search.toLowerCase());
        return matchesCat && matchesSearch;
    });

    return (
        <main className="pt-32 mt-6 md:pt-40 pb-20 px-4 md:px-12 bg-mesh min-h-screen">
            <div className="max-w-[1750px] mx-auto">
                {/* HEADER */}
                <div className="mb-12 text-center md:text-left">
                    <h1 className="text-4xl md:text-5xl font-black text-brand-dark uppercase italic tracking-tighter leading-none">
                        Ecosystem <span className="text-brand-orange">Insights</span>
                    </h1>
                </div>

                {/* FILTERS */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-16 pb-8 border-b border-slate-100">
                    <div className="flex gap-2 overflow-x-auto w-full md:w-auto pb-2">
                        {categories.map((cat) => (
                            <button key={cat} onClick={() => setActiveCat(cat)} 
                                className={`px-6 py-2.5 rounded-full text-[10px] font-black uppercase tracking-widest ${activeCat === cat ? 'bg-brand-orange text-white' : 'bg-white text-slate-400'}`}>
                                {cat}
                            </button>
                        ))}
                    </div>
                    <input type="text" placeholder="Search insights..." value={search} onChange={(e) => setSearch(e.target.value)}
                        className="w-full md:w-80 px-6 py-3 bg-white border rounded-full text-xs font-bold" />
                </div>

                {/* GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {filteredPosts.map((post) => (
                        <div key={post.id} className="group bg-white rounded-[2.5rem] border border-slate-100 overflow-hidden hover:shadow-2xl transition-all duration-500 flex flex-col">
                            <div className="relative aspect-video overflow-hidden">
                                <img src={`${post.image_path}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" alt={post.title} />
                                <div className="absolute top-6 left-6">
                                    <span className="bg-brand-dark/90 backdrop-blur-md text-white text-[8px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg">{post.category}</span>
                                </div>
                            </div>
                            <div className="p-8 flex flex-col flex-1">
                                <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mb-4">{post.date_published}</span>
                                <h3 className="text-xl font-black text-brand-dark uppercase tracking-tight leading-snug mb-4 line-clamp-2">{post.title}</h3>
                                <p className="text-sm text-slate-500 font-medium italic leading-relaxed mb-8 line-clamp-3">{post.excerpt}</p>
                            </div>
                        </div>
                    ))}
                    {filteredPosts.length === 0 && <p className="col-span-full text-center text-slate-400">No insights found.</p>}
                </div>
            </div>
        </main>
    );
};

export default Blog;